<template>
<section class="footer">
    <div class="footer_content">
        <div class="footer_apropos">
            <h4>À propos</h4>
            <p >Arnaques.biz est un site pédagogique sur les escroqueries financières en ligne.
                La collecte des données, la rédaction des textes et le développement web du site ont été réalisés par Boris Cassel, journaliste économique et développeur web.
                Le graphisme a été imaginé par <a target="_blank" href="https://www.behance.net/maelleam">Maëlle Amon-Moreau.</a> La réalisation de ce site a été encadrée par Wedodata dans le cadre d’un stage en 2020.</p>

                <!-- L'ensemble du projet a été supervisé par les équipes de la société <a target="_blank" href="https://www.wedodata.fr/">Wedodata</a>.-->
             </div>
        <div class="footer_contactez">
                <ContactMe />
            </div>
        <div class="footer_partagez" id="share" >
           <Share />
        </div>
        <!--<div class="footer_logo">
            <img src="img/icon/logowdd.svg" alt="logo de l'entreprise wedodata">
        </div>-->
    </div>
</section>

</template>

<script>
import ContactMe from "@/components/ContactHandler.vue"
import Share from "@/components/Share.vue";

export default{
        name:'myfooter',
        components : {
            ContactMe,
            Share
        }
}
</script>

<style>
.footer{
    position:relative;
    bottom:0;
    margin:0;
    padding-bottom:5vh;
    height:100%;
    width:100vw;
    display:flex;
    justify-content:center;
    background-color: #E0EEF5;
}

.footer_content{
    width:90%;
    height:100%;
    position:relative;
    display:flex;
    justify-content: space-between;
  }

.footer_apropos{
    align-self:baseline;
    height:90%;
    width:30%;
}


.footer_contactez{
    align-self: baseline;
    width:17.58%;


}

.footer_partagez{
    align-self:baseline;

}
.footer_logo{
    align-self:flex-end;
    width: 14%;
}



div.footer_content img{
        align-self : flex-end;
  }

section.footer a{
    font-family: 'Open Sans', Helvetica, serif;
    font-size: 16px;
    font-style: normal;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: 0px;
    text-align: left;
    text-decoration:none;
}

section.footer a:link {
    color:#2D3562;
    text-decoration:none;

}


</style>
<style scoped>



/* ---- RESPONSIVE -------*/

@media screen and (max-width:1000px) {

    .footer {
        position:relative;
        bottom:0;
        margin:0;
        height:100%;
        width:100vw;
        display:flex;
        align-items: center;
        background-color: #E0EEF5;
    }

    .footer_content {
            width:80%;
            height:100%;
            position:relative;
            display:flex;
            flex-direction:column;
            align-items: center;
            justify-content: flex-end;
    }



    .footer h4 {
        font-family: 'Open Sans', Helvetica, serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 33px;
        letter-spacing: 0px;
        text-align: left;
    }





    .footer p{
        font-family: 'Open Sans', Helvetica, serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0px;
        text-align: left;

    }


    .footer_apropos{
        align-self:flex-start;
        height:90%;
        width:80%;
    }

    .footer_logo{
        align-self:flex-start;
    }


}







</style>